import { track } from "~/modules/analytics/track";
import { TokenHoldersUserEvents } from "../analytics/events/tokenHolders";

// // // //

/**
 * trackLeagueTableTabChange
 * Tracks the event when a user changes a tab in the AssetTokenHolders component
 */
export function trackTokenHoldersTabChange(props: {
    prev: string;
    next: string;
    asset_id: number;
    asset_ticker: string;
}) {
    track(TokenHoldersUserEvents.ChangeTab, props);
}
